export default __webpack_public_path__ + "static/media/position_sticky.e4ce6408.gif";